<template>
  <img :src="tag" :alt="alt" />
</template>

<script setup lang="ts">
import { camelCase } from 'lodash';
import { computed, onMounted } from 'vue';

import { SvgNames, TAG_MAPPING } from './svgImports';

const { svg, alt = '' } = defineProps<{ svg: string; alt?: string }>();

onMounted(() => {
  if (!TAG_MAPPING[camelCase(svg) as SvgNames]) {
    console.warn(`SVG ${svg} not found`);
  }
});

const tag = computed(() => TAG_MAPPING[camelCase(svg) as SvgNames]);
</script>
